import styled from "styled-components"

import { Text } from "@minuthq/meatball-ui-react"

import { spacing } from "src/ui/spacing"

export function DataValue({
  value,
  description,
}: {
  value: React.ReactNode
  description: React.ReactNode
}) {
  return (
    <Grid>
      <Text variant="heading1" color="primary" contentType="number">
        {value}
      </Text>

      <Text variant="bodyS" color="secondary">
        {description}
      </Text>
    </Grid>
  )
}

const Grid = styled.div`
  display: grid;
  gap: ${spacing.XS};
`
